require('./dist/validate');
module.exports = 'ui.validate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-validate/index.js
// module id = 148
// module chunks = 0